import { render, staticRenderFns } from "./paidorderserviceitemrecord.vue?vue&type=template&id=5b336c16&"
import script from "./paidorderserviceitemrecord.vue?vue&type=script&lang=js&"
export * from "./paidorderserviceitemrecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports